import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Form, Select, Checkbox, Card, Table, Row, Col, Spin, Button, message,  Space } from 'antd';

const LoginRightsForm = () => {
  // Convert Y/N values to boolean and prepare days arrays
  // const convertDays = (prefix) => {
  //   if (!detailedRight) return [];
    
  //   // Define day mappings
  //   const dayMappings = [
  //     { key: 'sunday', abbr: 'Sun' },
  //     { key: 'monday', abbr: 'Mon' },
  //     { key: 'tuesday', abbr: 'Tue' },
  //     { key: 'wednesday', abbr: 'Wed' },
  //     { key: 'thursday', abbr: 'Thu' },
  //     { key: 'friday', abbr: 'Fri' },
  //     { key: 'saturday', abbr: 'Sat' }
  //   ];
    
  //   // Check if all_days flag is 'Y'
  //   const allDaysFlag = detailedRight[`${prefix}_all_days`] === 'Y';
    
  //   // If all_days is 'Y', return all days
  //   if (allDaysFlag) {
  //     return ['All', ...dayMappings.map(({ abbr }) => abbr)];
  //   }
    
  //   // Otherwise, only return days that are explicitly marked as 'Y'
  //   const selectedDays = dayMappings
  //     .filter(({ key }) => {
  //       const value = detailedRight[`${prefix}_${key}`];
  //       console.log(`${prefix}_${key}:`, value);
  //       return value === 'Y';
  //     })
  //     .map(({ abbr }) => abbr);
    
  //   // Add 'All' if all individual days are selected
  //   if (selectedDays.length === 7) {
  //     return ['All', ...selectedDays];
  //   }
    
  //   return selectedDays;
  // };
  const [form] = Form.useForm();
  const [dataSource, setDataSource] = useState([]);
  const [formdata, setFormData] = useState([]);
  const [moduleOptions, setModuleOptions] = useState([]);
  const [filteredForms, setFilteredForms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedForms, setSelectedForms] = useState([
    { key: Date.now(), form_name: '' }
  ]);
  const [selectedFormNames, setSelectedFormNames] = useState([]);
  const [existingRights, setExistingRights] = useState([]);
  const [loadingRights, setLoadingRights] = useState(false);

  const getAllAssignedFormNames = () => {
    const existingFormNames = (existingRights || []).map(right => right?.form_name).filter(Boolean);
    return [...new Set([...existingFormNames, ...(selectedFormNames || [])])];
  };
  const [editMode, setEditMode] = useState(false);
  // const [editingRight, setEditingRight] = useState(null);
  // const [detailedRight, setDetailedRight] = useState(null);

  const transactionOptions = [
    { value: 'Master', label: 'Master' },
    { value: 'Transactions', label: 'Transaction' },
    { value: 'Report', label: 'Report' },
    { value: 'View', label: 'View' }
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get('https://metalzulu-backend.onrender.com/api/v1/admistraterright/get-user-info', {
          withCredentials: true,
        });
        console.log(response, "first")
        setDataSource(response.data.data.UserValue?.rows || []);
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };

    const fetchFormData = async () => {
      try {
        const response = await axios.get('https://metalzulu-backend.onrender.com/api/v1/admistraterright/get-form-info', {
          withCredentials: true,
        });
        console.log(response, "second")
    
        const { formValue } = response.data.data;
    
        const validFormData = (formValue?.rows || []).filter(row => row.form_id && row.form_name);
    
        setFormData(validFormData);
      } catch (error) {
        console.error('Error fetching form data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
    fetchFormData();
  }, []);

  const handleUserChange = async (value) => {
    try {
      setLoadingRights(true);
      setSelectedFormNames([]);
      setSelectedForms([{ key: Date.now(), form_name: '' }]);
      
      // Fetch module options
      const moduleResponse = await axios.get(`https://metalzulu-backend.onrender.com/api/v1/admistraterright/get-user-info/${value}`, {
        withCredentials: true,
      });
      console.log(moduleResponse, "second")
      const options = moduleResponse.data.data.module?.rows.map((row) => ({
        value: row.get_module,
        label: row.get_module,
      }));

      setModuleOptions(options || []);
      form.setFieldsValue({ moduleType: '', transactionType: '' });

      // Fetch existing rights
      const rightsResponse = await axios.get(`https://metalzulu-backend.onrender.com/api/v1/admistraterright/login-rights/${value}`, {
        withCredentials: true,
      });
      console.log(rightsResponse, "second")
      setExistingRights(rightsResponse.data.data || []);
    } catch (error) {
      console.error('Error fetching user data:', error);
      message.error('Failed to fetch user data');
    } finally {
      setLoadingRights(false);
    }
  };

  const handleModuleAndTransactionChange = () => {
    const module = form.getFieldValue('moduleType');
    const transactionType = form.getFieldValue('transactionType');

    if (module && transactionType) {
      const filtered = formdata.filter(
        (form) => 
          form.module.toLowerCase() === module.toLowerCase() && 
          form.trans_id.toLowerCase() === transactionType.toLowerCase()
      );
      setFilteredForms(filtered);
    }
  };

  const handleAddForm = () => {
    const newForm = {
      key: Date.now(),
      form_name: '',
    };
    setSelectedForms([...selectedForms, newForm]);
  };

  const handleRemoveForm = (key) => {
    if (selectedForms.length > 1) {
      const removedForm = selectedForms.find(form => form.key === key);
      if (removedForm) {
        setSelectedFormNames(prevSelected => prevSelected.filter(name => name !== removedForm.form_name));
      }
      setSelectedForms(selectedForms.filter(form => form.key !== key));
    }
  };

  const handleFormNameChange = (value, key) => {
    setSelectedFormNames(prevSelected => [...(prevSelected || []), value]);
    setSelectedForms((selectedForms || []).map(form => {
      if (form?.key === key) {
        const selectedForm = (filteredForms || []).find(f => f?.form_name === value);
        return { ...form, form_name: value, form_id: selectedForm?.form_id };
      }
      return form;
    }));
  };
  

 


  const handleEdit = async (right) => {
    if (!right) {
      console.error('No right object provided to handleEdit');
      return;
    }

    setEditMode(true);
    // setEditingRight(right);
    
    console.log("API Response for editing right:", right);
    
    // Set form values with null checks
    form.setFieldsValue({
      user: right?.login_code || '',
      moduleType: right?.module || '',
      transactionType: right?.trans_id || ''
    });
  
    // Fetch detailed rights data for this specific form
    try {
      if (!right?.login_code) {
        console.error('No login_code provided');
        return;
      }

      const response = await axios.get(`https://metalzulu-backend.onrender.com/api/v1/admistraterright/login-rights/${right.login_code}`, {
        withCredentials: true
      });
      
      const rightData = response?.data?.data?.find(r => r?.form_id === right?.form_id);
      console.log("Detailed rights data:", JSON.stringify(rightData, null, 2));
      console.log("Full API response:", JSON.stringify(response?.data, null, 2));
      
      if (!rightData) {
        console.error("Could not find detailed rights data for form:", right?.form_id);
        return;
      }
      
      // setDetailedRight(rightData);

      // Helper function to get selected days based on permission type
      const getSelectedDays = (prefix) => {
        if (!prefix || !rightData) return [];
        
        const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
        const selectedDays = days
          .filter(day => rightData[`${prefix}_${day}`] === 'Y')
          .map(day => day?.charAt(0)?.toUpperCase() + day?.slice(1, 3));
        
        // Add 'All' if all_days is 'Y' or if all individual days are selected
        if (rightData[`${prefix}_all_days`] === 'Y' || selectedDays?.length === 7) {
          return ['All', ...(selectedDays || [])];
        }
        return selectedDays || [];
      };

      // Convert the API response to form state with null checks
      const formState = {
        key: Date.now(),
        form_name: rightData?.form_name || '',
        form_id: rightData?.form_id,
        add: rightData?.l_add === 'Y',
        modify: rightData?.l_modify === 'Y',
        delete: rightData?.l_delete === 'Y',
        query: rightData?.l_query === 'Y',
        // Get selected days for each permission type with null checks
        addDays: rightData?.l_add === 'Y' ? getSelectedDays('a') : [],
        modifyDays: rightData?.l_modify === 'Y' ? getSelectedDays('m') : [],
        deleteDays: rightData?.l_delete === 'Y' ? getSelectedDays('d') : [],
        queryDays: rightData?.l_query === 'Y' ? getSelectedDays('q') : []
      };
      
      console.log('Converted Form State:', formState);
      setSelectedForms([formState]);
    } catch (error) {
      console.error("Error fetching detailed rights data:", error);
      message.error("Failed to load detailed rights data");
    }
  };
  

  const handleSave = async () => {
    try {
      // Validate all mandatory fields
      try {
        await form.validateFields();
      } catch (error) {
        console.error('Form validation error:', error);
        message.error('Please fill all mandatory fields');
        return;
      }
      
      // Get form values after validation with null checks
      const formValues = form?.getFieldsValue() || {};
      
      if (!selectedForms || !Array.isArray(selectedForms)) {
        console.error('No forms selected or invalid forms data');
        message.error('No forms data available');
        return;
      }

      // Check if any form names are empty with null checks
      const hasEmptyFormName = (selectedForms || []).some(form => !form?.form_name);
      if (hasEmptyFormName) {
        message.error('Please select a form name for all forms');
        return;
      }

      // Check if at least one permission is selected for each form with null checks
      const noPermissionsSelected = (selectedForms || []).some((form) => {
        if (!form?.form_name) return false; // Skip validation for empty form names
        const permissions = [form?.add, form?.modify, form?.delete, form?.query];
        return permissions.every((perm) => !perm);
      });
      
      if (noPermissionsSelected) {
        message.error('Please select at least one permission (add/modify/delete/query) for each form');
        return;
      }

      // Debug logging for form data
      console.log('Form Data:', {
        formValues,
        selectedForms,
        editMode
      });

      const dataToSave = {
        user: formValues?.user || '',
        module: formValues?.moduleType || '',
        transactionType: formValues?.transactionType || '',
        isEdit: editMode || false,
        selectedForms: (selectedForms || []).map(form => ({
          formId: form?.form_id,
          formName: form?.form_name || '',
          add: form?.add ? 'Y' : 'N',
          modify: form?.modify ? 'Y' : 'N',
          delete: form?.delete ? 'Y' : 'N',
          query: form?.query ? 'Y' : 'N',
          addDays: form?.addDays || [],
          modifyDays: form?.modifyDays || [],
          deleteDays: form?.deleteDays || [],
          queryDays: form?.queryDays || []
        }))
      };
      
      await axios.post('https://metalzulu-backend.onrender.com/api/v1/admistraterright/save-login-rights', dataToSave, {
        withCredentials: true,
      });
      
      // Clear the form but maintain one default row
      form.resetFields();
      setSelectedForms([{ 
        key: Date.now(), 
        form_name: '',
        add: false,
        modify: false,
        delete: false,
        query: false,
        addDays: [],
        modifyDays: [],
        deleteDays: [],
        queryDays: []
      }]);
      
      message.success('Data saved successfully');
      
      // Reset edit mode and refresh list
      setEditMode(false);
      // setEditingRight(null);
      if (formValues.user) {
        handleUserChange(formValues.user);
      }
    } catch (error) {
      console.error('Error saving data:', error);
      message.error('Failed to save data');
    }
  };
  

  const columns = [
    {
      title: <>Forms List <span style={{ color: "red" }}>*</span></>,
      dataIndex: 'form_name',
      width: 200,
      render: (_, record) => (
        <Select
        style={{ width: '100%',textAlign: 'left',fontWeight:1200 }}
         
          value={record?.form_name || ''}
          onChange={(value) => handleFormNameChange(value, record?.key)}
        >
          {filteredForms
            .filter(form => !getAllAssignedFormNames().includes(form.form_name))
            .map(form => (
              <Select.Option key={form.form_id} value={form.form_name}>
                {form.form_name}
              </Select.Option>
            ))
          }
        </Select>
      ),
    },
    {
      title: 'Add/Preview',
      dataIndex: 'add',
      width: 200,
      render: (_, record) => (
        <div>
          <Checkbox
            checked={record?.add}
            onChange={(e) => {
              const checked = e.target.checked;
              const updatedForms = selectedForms?.map(form =>
                form?.key === record?.key ? { 
                  ...form, 
                  add: checked,
                  // If unchecking, clear days. If checking, only select "All"
                  addDays: checked ? ['All'] : []
                } : form
              ) || [];
              setSelectedForms(updatedForms);
            }}
          />
          <div style={{ marginTop: 10 }}>
            
            <Checkbox.Group
              value={record?.addDays || []}
              onChange={(values) => {
                const allChecked = values.includes('All');
                let updatedValues;
                
                if (allChecked && !record?.addDays?.includes('All')) {
                  // If "All" was just checked, only add "All"
                  updatedValues = ['All'];
                } else if (!allChecked && record?.addDays?.includes('All')) {
                  // If "All" was just unchecked, keep other selections
                  updatedValues = values.filter(v => v !== 'All');
                } else {
                  // Normal day selection/deselection
                  // First, remove 'All' if it exists in values
                  updatedValues = values.filter(v => v !== 'All');
                  
                  // Then check if all individual days are selected
                  const hasAllDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
                    .every(day => updatedValues.includes(day));
                  
                  // Only add 'All' back if all days are selected
                  if (hasAllDays) {
                    updatedValues = ['All', ...updatedValues];
                  }
                  
                  // Debug logging
                  console.log('Add Days Update:', {
                    originalValues: values,
                    updatedValues,
                    hasAllDays
                  });
                }
                
                const updatedForms = (selectedForms || []).map(form =>
                  form?.key === record?.key ? { 
                    ...form, 
                    addDays: updatedValues || [],
                    add: (updatedValues || []).length > 0 
                  } : form
                ) || [];
                setSelectedForms(updatedForms);
              }}
            >
              {['All', 'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(day => {
                // Add debug logging for checkbox rendering
                console.log('Rendering add checkbox for day:', {
                  day,
                  record,
                  addDays: record?.addDays,
                  hasAll: record?.addDays?.includes('All')
                });
                
                return (
                  <Checkbox 
                    key={day} 
                    value={day}
                    disabled={false}
                  >
                    {day}
                  </Checkbox>
                );
              })}
            </Checkbox.Group>
          </div>
        </div>
      ),
    },
    
    {
      title: 'Modify/Print',
      dataIndex: 'modify',
      width: 200,
      render: (_, record) => (
        <div>
          <Checkbox
            checked={record?.modify}
            onChange={(e) => {
              const checked = e.target.checked;
              const updatedForms = selectedForms?.map(form =>
                form?.key === record?.key ? { 
                  ...form, 
                  modify: checked,
                  // If unchecking, clear days. If checking, only select "All"
                  modifyDays: checked ? ['All'] : []
                } : form
              ) || [];
              setSelectedForms(updatedForms);
            }}
          />
          <div style={{ marginTop: 10 }}>
            <Checkbox.Group
              value={record?.modifyDays || []}
              onChange={(values) => {
                const allChecked = values.includes('All');
                let updatedValues;
                
                if (allChecked && !record?.modifyDays?.includes('All')) {
                  // If "All" was just checked, only add "All"
                  updatedValues = ['All'];
                } else if (!allChecked && record?.modifyDays?.includes('All')) {
                  // If "All" was just unchecked, keep other selections
                  updatedValues = values.filter(v => v !== 'All');
                } else {
                  // Normal day selection/deselection
                  // First, remove 'All' if it exists in values
                  updatedValues = values.filter(v => v !== 'All');
                  
                  // Then check if all individual days are selected
                  const hasAllDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
                    .every(day => updatedValues.includes(day));
                  
                  // Only add 'All' back if all days are selected
                  if (hasAllDays) {
                    updatedValues = ['All', ...updatedValues];
                  }
                  
                  // Debug logging
                  console.log('Modify Days Update:', {
                    originalValues: values,
                    updatedValues,
                    hasAllDays
                  });
                }
                
                const updatedForms = (selectedForms || []).map(form =>
                  form?.key === record?.key ? { 
                    ...form, 
                    modifyDays: updatedValues || [],
                    modify: (updatedValues || []).length > 0  // Enable modify when days are selected
                  } : form
                ) || [];
                setSelectedForms(updatedForms);
              }}
            >
              {['All', 'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(day => {
                // Add debug logging for checkbox rendering
                console.log('Rendering modify checkbox for day:', {
                  day,
                  record,
                  modifyDays: record?.modifyDays,
                  hasAll: record?.modifyDays?.includes('All')
                });
                
                return (
                  <Checkbox 
                    key={day} 
                    value={day}
                    disabled={false}
                  >
                    {day}
                  </Checkbox>
                );
              })}
            </Checkbox.Group>
          </div>
        </div>
      ),
    },
    {
      title: 'Delete/File',
      dataIndex: 'delete',
      width: 200,
      render: (_, record) => (
        <div>
          <Checkbox
            checked={record?.delete}
            onChange={(e) => {
              const checked = e.target.checked;
              const updatedForms = selectedForms?.map(form =>
                form?.key === record?.key ? { 
                  ...form, 
                  delete: checked,
                  // If unchecking, clear days. If checking, only select "All"
                  deleteDays: checked ? ['All'] : []
                } : form
              ) || [];
              setSelectedForms(updatedForms);
            }}
          />
          <div style={{ marginTop: 10 }}>
            <Checkbox.Group
              value={record?.deleteDays || []}
              onChange={(values) => {
                const allChecked = values.includes('All');
                let updatedValues;
                
                if (allChecked && !record?.deleteDays?.includes('All')) {
                  // If "All" was just checked, only add "All"
                  updatedValues = ['All'];
                } else if (!allChecked && record?.deleteDays?.includes('All')) {
                  // If "All" was just unchecked, keep other selections
                  updatedValues = values.filter(v => v !== 'All');
                } else {
                  // Normal day selection/deselection
                  // First, remove 'All' if it exists in values
                  updatedValues = values.filter(v => v !== 'All');
                  
                  // Then check if all individual days are selected
                  const hasAllDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
                    .every(day => updatedValues.includes(day));
                  
                  // Only add 'All' back if all days are selected
                  if (hasAllDays) {
                    updatedValues = ['All', ...updatedValues];
                  }
                  
                  // Debug logging
                  console.log('Delete Days Update:', {
                    originalValues: values,
                    updatedValues,
                    hasAllDays
                  });
                }
                
                const updatedForms = (selectedForms || []).map(form =>
                  form?.key === record?.key ? { 
                    ...form, 
                    deleteDays: updatedValues || [],
                    delete: (updatedValues || []).length > 0  // Enable delete when days are selected
                  } : form
                ) || [];
                setSelectedForms(updatedForms);
              }}
            >
              {['All', 'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(day => {
                // Add debug logging for checkbox rendering
                console.log('Rendering delete checkbox for day:', {
                  day,
                  record,
                  deleteDays: record?.deleteDays,
                  hasAll: record?.deleteDays?.includes('All')
                });
                
                return (
                  <Checkbox 
                    key={day} 
                    value={day}
                    disabled={false}
                  >
                    {day}
                  </Checkbox>
                );
              })}
            </Checkbox.Group>
          </div>
        </div>
      ),
    },
    {
      title: 'Query/Mail',
      dataIndex: 'query',
      width: 200,
      render: (_, record) => (
        <div>
          <Checkbox
            checked={record?.query}
            onChange={(e) => {
              const checked = e.target.checked;
              const updatedForms = selectedForms?.map(form =>
                form?.key === record?.key ? { 
                  ...form, 
                  query: checked,
                  // If unchecking, clear days. If checking, only select "All"
                  queryDays: checked ? ['All'] : []
                } : form
              ) || [];
              setSelectedForms(updatedForms);
            }}
          />
          <div style={{ marginTop: 10 }}>
            <Checkbox.Group
              value={record?.queryDays || []}
              onChange={(values) => {
                const allChecked = values.includes('All');
                let updatedValues;
                
                if (allChecked && !record?.queryDays?.includes('All')) {
                  // If "All" was just checked, only add "All"
                  updatedValues = ['All'];
                } else if (!allChecked && record?.queryDays?.includes('All')) {
                  // If "All" was just unchecked, keep other selections
                  updatedValues = values.filter(v => v !== 'All');
                } else {
                  // Normal day selection/deselection
                  // First, remove 'All' if it exists in values
                  updatedValues = values.filter(v => v !== 'All');
                  
                  // Then check if all individual days are selected
                  const hasAllDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
                    .every(day => updatedValues.includes(day));
                  
                  // Only add 'All' back if all days are selected
                  if (hasAllDays) {
                    updatedValues = ['All', ...updatedValues];
                  }
                  
                  // Debug logging
                  console.log('Query Days Update:', {
                    originalValues: values,
                    updatedValues,
                    hasAllDays
                  });
                }
                
                const updatedForms = (selectedForms || []).map(form =>
                  form?.key === record?.key ? { 
                    ...form, 
                    queryDays: updatedValues || [],
                    query: (updatedValues || []).length > 0  // Enable query when days are selected
                  } : form
                ) || [];
                setSelectedForms(updatedForms);
              }}
            >
              {['All', 'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(day => {
                // Add debug logging for checkbox rendering
                console.log('Rendering query checkbox for day:', {
                  day,
                  record,
                  queryDays: record?.queryDays,
                  hasAll: record?.queryDays?.includes('All')
                });
                
                return (
                  <Checkbox 
                    key={day} 
                    value={day}
                    disabled={false}
                  >
                    {day}
                  </Checkbox>
                );
              })}
            </Checkbox.Group>
          </div>
        </div>
      ),
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <Button onClick={() => handleRemoveForm(record.key)} type="link" danger>
          Remove
        </Button>
      ),
    },
  ];

  if (loading) {
    return <Spin size="large" style={{ display: 'block', margin: '100px auto' }} />;
  }

  // const handleDeleteRight = async (specCode, formId) => {
  //   const hide = message.loading('Deleting right...', 0);
  //   try {
  //     const result = await new Promise((resolve) => {
  //       Modal.confirm({
  //         title: 'Are you sure you want to delete this right?',
  //         content: 'This action cannot be undone.',
  //         okText: 'Yes',
  //         okType: 'danger',
  //         cancelText: 'No',
  //         onOk: () => resolve(true),
  //         onCancel: () => resolve(false),
  //       });
  //     });

  //     if (!result) {
  //       hide();
  //       return;
  //     }

  //     await axios.delete(`https://metalzulu-backend.onrender.com/api/v1/admistraterright/login-rights/${specCode}/${formId}`, {
  //       withCredentials: true,
  //     });
      
  //     hide();
  //     message.success('Right deleted successfully');
      
  //     // Refresh the list
  //     if (form.getFieldValue('user')) {
  //       handleUserChange(form.getFieldValue('user'));
  //     }
  //   } catch (error) {
  //     hide();
  //     console.error('Error deleting right:', error);
  //     message.error('Failed to delete right: ' + (error.response?.data?.message || error.message));
  //   }
  // };

  const existingRightsColumns = [
    {
      title: 'Form Name',
      dataIndex: 'form_name',
      key: 'form_name',
      render: (text) => <strong>{text}</strong>,
    },
    {
      title: 'Module',
      dataIndex: 'module',
      key: 'module',
    },
    {
      title: 'Transaction Type',
      dataIndex: 'trans_id',
      key: 'trans_id',
    },
    {
      title: 'Add',
      dataIndex: 'l_add',
      key: 'l_add',
      render: (text) => text === 'Y' ? 'Yes' : 'No',
    },
    {
      title: 'Modify',
      dataIndex: 'l_modify',
      key: 'l_modify',
      render: (text) => text === 'Y' ? 'Yes' : 'No',
    },
    {
      title: 'Delete',
      dataIndex: 'l_delete',
      key: 'l_delete',
      render: (text) => text === 'Y' ? 'Yes' : 'No',
    },
    {
      title: 'Query',
      dataIndex: 'l_query',
      key: 'l_query',
      render: (text) => text === 'Y' ? 'Yes' : 'No',
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <Space>
          <Button 
            type="link"
            onClick={() => handleEdit(record)}
          >
            Edit
          </Button>
          {/* <Button 
            type="link" 
            danger
            onClick={() => handleDeleteRight(record.login_code, record.form_id)}
          >
            Delete
          </Button> */}
        </Space>
      ),
    },
  ];

  return (
    <Card title="Login Rights">
      <Form form={form} layout="vertical">
        <Row gutter={16}>
          <Col span={6}>
            <Form.Item 
              label={<>User </>}
              name="user"
              rules={[{ required: true, message: 'Please fill all mandatory fields' }]}>
              <Select
                style={{ width: '100%',textAlign: 'left' }}
                placeholder="Select User"
                options={dataSource.map((row) => ({
                  value: row.spec_code,
                  label: row.user_name || 'N/A',
                }))}
                onChange={handleUserChange}
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item 
              label={<>Module </>}
              name="moduleType"
              rules={[{ required: true, message: 'Please fill all mandatory fields' }]}>
              <Select
               style={{ width: '100%',textAlign: 'left' }}
                placeholder="Select Module"
                options={moduleOptions}
                onChange={(value) => {
                  form.setFieldsValue({ moduleType: value });
                  handleModuleAndTransactionChange();
                }}
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item 
              label={<>Transaction Type </>}
              name="transactionType"
              rules={[{ required: true, message: 'Please fill all mandatory fields' }]}>
              <Select
               style={{ width: '100%',textAlign: 'left' }}
                placeholder="Select Type"
                options={transactionOptions}
                onChange={(value) => {
                  form.setFieldsValue({ transactionType: value });
                  handleModuleAndTransactionChange();
                }}
              />
            </Form.Item>
          </Col>
        </Row>

        <Button onClick={handleAddForm} type="primary" style={{ marginBottom: 16 }}>
          Add Form
        </Button>

        <Table
          columns={columns}
          dataSource={selectedForms}
          pagination={false}
          scroll={{ y: 300 }}
          bordered
          size="small"
        />

        <Button onClick={handleSave} type="primary" style={{ marginTop: 16, marginBottom: 24 }}>
          Save
        </Button>
      </Form>

      {form.getFieldValue('user') && (
        <Card title="Existing Rights" style={{ marginTop: 24 }}>
          <Table
            loading={loadingRights}
            columns={existingRightsColumns}
            dataSource={existingRights}
            rowKey="rights_id"
            pagination={false}
            scroll={{ y: 300 }}
            bordered
            size="small"
          />
        </Card>
      )}
    </Card>
  );
};

export default LoginRightsForm;
